import { M8Price } from 'services/production/types';
import { Tariff } from 'types/state';

export const normalizeM8Price = (price: M8Price) => ({
  toTariff(): Tariff {
    return {
      id: price.id,
      cost: price.amount,
      createdAt: price.createdOn,
      expiresAt: price.endDate,
      startsAt: price.beginDate,
    };
  },
});
